import { DEFAULT_NETWORK, NETWORKS } from '../web3/constants';

export const youTubeGetID = (url: string) => {
  const [a, , b] = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  if (b !== undefined) {
    return b.split(/[^0-9a-z_-]/i)[0];
  } else {
    return a;
  }
};

export const getSongAttributeValue = (attributes, attrName) => {
  const attr = attributes?.find((a) => a.trait_type === attrName);
  return attr?.value;
};

export const validateBeforeWriting = async (address, chainId, toast) => {
  if (!address) {
    toast({
      status: 'error',
      title: 'An error occurred',
      description: 'Please connect to the wallet before placing the bid',
    });
    throw new Error('error');
  }

  if (chainId !== Number(DEFAULT_NETWORK)) {
    toast({
      status: 'error',
      title: 'An error occurred',
      description: `You are not connected to the ${NETWORKS[DEFAULT_NETWORK].name}`,
    });

    throw new Error('error');
  }
};
